<div id="<%= dom_id solo %>" class="w-full sm:w-auto my-5 space-y-5">
  <div>
    <strong class="block font-medium mb-1">Heat:</strong>
    <%= solo.heat_id %>
  </div>
  <div>
    <strong class="block font-medium mb-1">Combo dance:</strong>
    <%= solo.combo_dance_id %>
  </div>
  <div>
    <strong class="block font-medium mb-1">Category override:</strong>
    <%= solo.category_override_id %>
  </div>
  <div>
    <strong class="block font-medium mb-1">Artist:</strong>
    <%= solo.artist %>
  </div>
  <div>
    <strong class="block font-medium mb-1">Song:</strong>
    <%= solo.song %>
  </div>
  <div>
    <strong class="block font-medium mb-1">Order:</strong>
    <%= solo.order %>
  </div>
</div>
